import { render } from "./discount_form.vue?vue&type=template&id=22fff3ef"
import script from "./discount_form.vue?vue&type=script&lang=js"
export * from "./discount_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__